@if (menus.length == 0) {
  <div class="waiting-spinner">
    <mat-spinner strokeWidth="2" diameter="50"></mat-spinner>
    <p>Loading...</p>
  </div>
} @else {
  @for (menu of menus; track $index; let last = $last) {
    <app-portal-sidebar-drawer
      [navList]="menu.items"
      [title]="menu.title"
      (linkClick)="onClose()"
    ></app-portal-sidebar-drawer>
    @if (!last) {
      <mat-divider></mat-divider>
    }
  }
}
